<template>
  <div
    class="custom-modal fixed top-0 left-0 w-screen h-screen z-[100001] flex items-center justify-center opacity-0 pointer-events-none transition-all duration-500"
    id="tutco-mc-sign-up-modal"
    :class="{ 'opacity-100 pointer-events-auto': state.isVisible }">
    <div
      class="absolute top-0 left-0 w-full h-full z-10 opacity-70 bg-black backdrop-blur-lg"
      @click="closeModal"></div>
    <div class="relative w-[530px] h-full z-20 flex items-center">
      <div class="relative w-full h-fit max-h-full bg-white overflow-y-auto rounded-2xl">
        <div
          class="absolute top-2 right-2 z-10 cursor-pointer group"
          @click="closeModal">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="block w-5 h-auto">
            <path
              d="M22.9999 1.35556L1.00132 23.3542"
              stroke="#553F3F"
              stroke-width="2"
              stroke-linecap="round"
              class="transition-all duration-300 group-hover:stroke-red" />
            <path
              d="M22.9999 23.3554L1.00132 1.35678"
              stroke="#553F3F"
              stroke-width="2"
              stroke-linecap="round"
              class="transition-all duration-300 group-hover:stroke-red" />
          </svg>
        </div>
        <div class="w-full px-4 md:px-12 py-4 md:py-12">
          <div class="w-full text-2xl font-bold">
            {{ state.modalTitle }}
          </div>
          <div id="mc_embed_shell">&nbsp;</div>
          <div id="mc_embed_signup">
            <form
              action="https://tutcosureheat.us12.list-manage.com/subscribe/post?u=cb0711722e4f651e19bac13fa&amp;id=2a1f265ba9&amp;v_id=6822&amp;f_id=00bd4ae0f0"
              class="validate"
              id="mc-embedded-subscribe-form"
              method="post"
              name="mc-embedded-subscribe-form"
              target="_blank">
              <div id="mc_embed_signup_scroll">
                <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>

                <div class="mc-field-group">
                  <label for="mce-EMAIL">Email Address <span class="asterisk">*</span></label
                  ><input
                    class="required email"
                    id="mce-EMAIL"
                    name="EMAIL"
                    required=""
                    type="email"
                    value=""
                    autocomplete="on" />
                </div>

                <div class="mc-field-group">
                  <label for="mce-FNAME">First Name </label
                  ><input
                    class="text"
                    id="mce-FNAME"
                    name="FNAME"
                    type="text"
                    value="" />
                </div>

                <div class="mc-field-group">
                  <label for="mce-LNAME">Last Name </label
                  ><input
                    class="text"
                    id="mce-LNAME"
                    name="LNAME"
                    type="text"
                    value="" />
                </div>

                <div
                  class="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group"
                  id="mergeRow-gdpr">
                  <div class="content__gdpr">
                    <p>
                      You can unsubscribe at any time by clicking the link in the footer of our emails. For information about our privacy practices,
                      please see the&nbsp;<a
                        href="https://www.smiths.com/privacy"
                        target="_blank"
                        >Smiths Group Privacy Statement.</a
                      >
                    </p>
                  </div>

                  <div class="content__gdprLegal">
                    <p>
                      We use Mailchimp as our marketing platform. By clicking below to subscribe, you acknowledge that your information will be
                      transferred to Mailchimp for processing. Check more info about
                      <a
                        rel="noopener noreferrer"
                        href="https://mailchimp.com/legal/terms"
                        >Mailchimp&#39;s privacy practices</a
                      >.
                    </p>
                  </div>
                </div>

                <div
                  class="clear"
                  id="mce-responses">
                  <div
                    class="response"
                    id="mce-error-response"
                    style="display: none">
                    &nbsp;
                  </div>

                  <div
                    class="response"
                    id="mce-success-response"
                    style="display: none">
                    &nbsp;
                  </div>
                </div>

                <div
                  aria-hidden="true"
                  style="position: absolute; left: -5000px">
                  <input
                    name="b_cb0711722e4f651e19bac13fa_2a1f265ba9"
                    tabindex="-1"
                    type="text"
                    value="" />
                </div>

                <div class="clear">
                  <input
                    class="button"
                    :class="{ 'pointer-events-none grayscale': state.isButtonDisabled }"
                    id="mc-embedded-subscribe"
                    name="subscribe"
                    type="submit"
                    value="Subscribe" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from 'vue';
import GlobalHelper from '@/helpers/global/global.helper';

const DEFAULT_MODAL_TITLE: string = 'Sign up for newsletter';
const SIGN_UP_MODAL_VISIBILITY_COOKIE_KEY = 'signUpModalVisibilityCookieKey_' + COMPANY_UID;

const state = reactive({
  isVisible: false as boolean,
  modalTitle: DEFAULT_MODAL_TITLE as string,
  isSuccessInfoVisible: false as boolean,
  clickedProtectedLink: null as any,
  isButtonDisabled: false as boolean,
});

const showModal = () => {
  // Show Sign Up Modal Logic
};

const closeModal = () => {
  state.isVisible = false;

  setTimeout(() => {
    state.modalTitle = DEFAULT_MODAL_TITLE;
    state.isButtonDisabled = false;

    document.querySelector('#mce-success-response').style.display = 'none';
    document.querySelector('#mce-error-response').style.display = 'none';

    const mceEmailInput = document.querySelector('#mce-EMAIL');
    mceEmailInput.value = '';
    mceEmailInput.classList.remove('mce_inline_error');
    if (mceEmailInput.nextSibling !== null) {
      mceEmailInput.nextSibling.style.display = 'none';
    }

    document.querySelector('#mce-FNAME').value = '';
    document.querySelector('#mce-LNAME').value = '';
  }, 1000);
};

const initMailChimpFields = () => {
  (function () {
    window.fnames = ['EMAIL', 'FNAME', 'LNAME', 'ADDRESS', 'PHONE'];
    window.ftypes = ['email', 'text', 'text', 'address', 'phone'];
  })();
};

const formSubmitLogic = () => {
  const form = document.getElementById('mc-embedded-subscribe-form');

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    const formData = new FormData(form);
    const actionURL = form.action;

    setTimeout(() => {
      if (!form.querySelector('#mce-EMAIL').classList.contains('mce_inline_error')) {
        state.isButtonDisabled = true;
        fetch(actionURL, {
          method: 'POST',
          body: formData,
          mode: 'no-cors',
          headers: { Accept: 'application/json' },
        })
          .then((response) => response.text())
          .then((data) => {
            document.getElementById('mce-success-response').innerHTML = 'Thank you for subscribing!';
            document.getElementById('mce-success-response').style.display = 'block';
            document.getElementById('mce-error-response').style.display = 'none';

            GlobalHelper.setCookie(SIGN_UP_MODAL_VISIBILITY_COOKIE_KEY, 'hidden', 365 * 24);
            setTimeout(() => {
              closeModal();
            }, 3000);
          })
          .catch((error) => {
            document.getElementById('mce-error-response').innerHTML = 'An error occurred. Please try again.';
            document.getElementById('mce-error-response').style.display = 'block';
            document.getElementById('mce-success-response').style.display = 'none';
          });
      }
    }, 100);
  });
};

const protectedLinksLogic = () => {
  const protectedLinksList = document.querySelectorAll('a[data-link-is-protected="true"]');
  if (protectedLinksList.length > 0 && GlobalHelper.readCookie(SIGN_UP_MODAL_VISIBILITY_COOKIE_KEY) === null) {
    initMailChimpFields();

    protectedLinksList.forEach(function (link) {
      if (link.hasAttribute('download')) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          state.clickedProtectedLink = link;
          state.modalTitle = 'Sign up for our newsletter to download.';
          state.isVisible = true;
        });
      }
    });
  }
};

const joinOurEmailListLogic = () => {
  const joinOurEmailListButton = document.querySelector('.join-our-email-list-button');
  if (joinOurEmailListButton !== null) {
    initMailChimpFields();

    joinOurEmailListButton.addEventListener('click', () => {
      state.isVisible = true;
    });
  }
};

onMounted(() => {
  showModal();
  protectedLinksLogic();
  joinOurEmailListLogic();
  formSubmitLogic();
});
</script>

<style lang="scss">
/* MailChimp Form Embed Code - Classic - 12/17/2015 v10.7 */
#mc_embed_signup form {
  display: block;
  position: relative;
  text-align: left;
  margin: 20px;
}
#mc_embed_signup h2 {
  font-weight: bold;
  padding: 0;
  margin: 15px 0;
  font-size: 1.4em;
}
#mc_embed_signup input {
  border: 1px solid #abb0b2;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
#mc_embed_signup input[type='checkbox'] {
  -webkit-appearance: checkbox;
}
#mc_embed_signup input[type='radio'] {
  -webkit-appearance: radio;
}
#mc_embed_signup input:focus {
  border-color: #333;
}
#mc_embed_signup .button {
  clear: both;
  background-color: #111;
  border: 0 none;
  border-radius: 4px;
  transition: all 0.23s ease-in-out 0s;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  font-size: 15px;
  font-weight: normal;
  height: 32px;
  line-height: 32px;
  margin: 0 5px 10px 0;
  padding: 0 22px;
  text-align: center;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  width: fit-content;
  width: -moz-fit-content;
}
#mc_embed_signup .button:hover {
  background-color: #222;
}
#mc_embed_signup .small-meta {
  font-size: 11px;
}
#mc_embed_signup .nowrap {
  white-space: nowrap;
}

#mc_embed_signup .mc-field-group {
  clear: left;
  position: relative;
  width: 96%;
  padding-bottom: 3%;
  min-height: 50px;
  display: grid;
}
#mc_embed_signup .size1of2 {
  clear: none;
  float: left;
  display: inline-block;
  width: 46%;
  margin-right: 4%;
}
* html #mc_embed_signup .size1of2 {
  margin-right: 2%; /* Fix for IE6 double margins. */
}
#mc_embed_signup .mc-field-group label {
  display: block;
  margin-bottom: 3px;
}
#mc_embed_signup .mc-field-group input {
  display: block;
  width: 100%;
  padding: 8px 0;
  text-indent: 2%;
}
#mc_embed_signup .mc-field-group select {
  display: inline-block;
  width: 99%;
  padding: 5px 0;
  margin-bottom: 2px;
}
#mc_embed_signup .mc-address-fields-group {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 96%;
  gap: 15px;
}
#mc_embed_signup .mc-sms-phone-group {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 96%;
  gap: 15px;
  padding-top: 5px;
}

#mc_embed_signup .datefield,
#mc_embed_signup .phonefield-us {
  padding: 5px 0;
}
#mc_embed_signup .datefield input,
#mc_embed_signup .phonefield-us input {
  display: inline;
  width: 60px;
  margin: 0 2px;
  letter-spacing: 1px;
  text-align: center;
  padding: 5px 0 2px 0;
}
#mc_embed_signup .phonefield-us .phonearea input,
#mc_embed_signup .phonefield-us .phonedetail1 input {
  width: 40px;
}
#mc_embed_signup .datefield .monthfield input,
#mc_embed_signup .datefield .dayfield input {
  width: 30px;
}
#mc_embed_signup .datefield label,
#mc_embed_signup .phonefield-us label {
  display: none;
}

#mc_embed_signup .indicates-required {
  text-align: right;
  font-size: 11px;
  margin-right: 4%;
}
#mc_embed_signup .asterisk {
  color: #e85c41;
  font-size: 150%;
  font-weight: normal;
  position: relative;
  top: 5px;
}
#mc_embed_signup .clear {
  clear: both;
}
#mc_embed_signup .foot {
  display: grid;
  grid-template-columns: 3fr 1fr;
  width: 96%;
  align-items: center;
}
@media screen and (max-width: 400px) {
  #mc_embed_signup .foot {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    align-items: center;
  }
}

@media screen and (max-width: 400px) {
  #mc_embed_signup .referralBadge {
    width: 50%;
  }
}

#mc_embed_signup .brandingLogo {
  justify-self: right;
}
@media screen and (max-width: 400px) {
  #mc_embed_signup .brandingLogo {
    justify-self: left;
  }
}

#mc_embed_signup .mc-field-group.input-group ul {
  margin: 0;
  padding: 5px 0;
  list-style: none;
}
#mc_embed_signup .mc-field-group.input-group ul li {
  display: block;
  padding: 3px 0;
  margin: 0;
}
#mc_embed_signup .mc-field-group.input-group label {
  display: inline;
}
#mc_embed_signup .mc-field-group.input-group input {
  display: inline;
  width: auto;
  border: none;
}

#mc_embed_signup div#mce-responses {
  float: left;
  top: -1.4em;
  padding: 0em 0.5em 0em 0.5em;
  overflow: hidden;
  width: 90%;
  margin: 0 5%;
  clear: both;
}
#mc_embed_signup div.response {
  margin: 1em 0;
  padding: 1em 0.5em 0.5em 0;
  font-weight: bold;
  float: left;
  top: -1.5em;
  z-index: 1;
  width: 80%;
}
#mc_embed_signup #mce-error-response {
  display: none;
}
#mc_embed_signup #mce-success-response {
  color: #529214;
  display: none;
}
#mc_embed_signup label.error {
  display: block;
  float: none;
  width: auto;
  margin-left: 1.05em;
  text-align: left;
  padding: 0.5em 0;
}
#mc_embed_signup .helper_text {
  color: #8d8985;
  margin-top: 2px;
  display: inline-block;
  padding: 3px;
  background-color: rgba(255, 255, 255, 0.85);
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  z-index: 1;
}

#mc-embedded-subscribe {
  clear: both;
  width: auto;
  display: block;
  margin: 1em 0 1em 5%;
}
#mc_embed_signup #num-subscribers {
  font-size: 1.1em;
}
#mc_embed_signup #num-subscribers span {
  padding: 0.5em;
  border: 1px solid #ccc;
  margin-right: 0.5em;
  font-weight: bold;
}

#mc_embed_signup #mc-embedded-subscribe-form div.mce_inline_error {
  display: inline-block;
  margin: 2px 0 1em 0;
  padding: 3px;
  background-color: rgba(255, 255, 255, 0.85);
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  z-index: 1;
  color: #e85c41;
}
#mc_embed_signup #mc-embedded-subscribe-form input.mce_inline_error {
  border: 2px solid #e85c41;
}

#tutco-mc-sign-up-modal {
  #mc_embed_signup {
    background: #fff;
    font:
      14px Helvetica,
      Arial,
      sans-serif;
  }

  #mc_embed_signup form {
    margin: 0;
  }

  #mc-embedded-subscribe-form input[type='checkbox'] {
    display: inline;
    width: auto;
    margin-right: 10px;
  }
  #mergeRow-gdpr {
    margin-top: 20px;
  }
  #mergeRow-gdpr fieldset label {
    font-weight: normal;
  }
  #mc-embedded-subscribe-form .mc_fieldset {
    border: none;
    min-height: 0px;
    padding-bottom: 0px;
  }

  #mc-embedded-subscribe {
    background: #e31937;
  }
}
</style>
